"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _link = _interopRequireDefault(require("next/link"));
var _react = _interopRequireWildcard(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _checkout = require("../context/checkout");
var _useCheckoutPages = require("../hooks/useCheckoutPages");
var _WizardStep = _interopRequireDefault(require("./designsystem/WizardStep"));
const _excluded = ["route"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const CheckoutSteps = ({
  paymentType,
  loading,
  onlyTicketsInCart
}) => {
  const pages = (0, _useCheckoutPages.useCheckoutPages)(paymentType, onlyTicketsInCart);
  return __jsx(Container, {
    width: 1
  }, pages.map(({
    route,
    title
  }, i) => __jsx(CheckoutStep, {
    key: route,
    step: i + 1,
    route: route
  }, loading && __jsx(_reactLoadingSkeleton.default, {
    height: "2rem",
    width: "6rem"
  }), !loading && title)));
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(CheckoutSteps);
const useVariant = pageRoute => {
  const [state] = (0, _checkout.useCheckout)();
  const pageState = state.pages[pageRoute];
  const pages = (0, _useCheckoutPages.useCheckoutPages)();
  const {
    activeStep
  } = (0, _useCheckoutPages.useCheckoutPageMeta)();
  const pageStep = pages.findIndex(({
    route
  }) => route === pageRoute);
  const prevPageState = state.pages[pages[pageStep - 1]?.route];
  if (activeStep === pageStep) {
    return {
      variant: 'active',
      valid: prevPageState?.valid && pageStep !== pages.length - 1
    };
  }
  if (pageState && !pageState.valid) {
    return {
      variant: 'todo',
      navigationAllowed: pageState.visited
    };
  }
  if (activeStep === pages.length - 1) {
    return {
      variant: 'disabled'
    };
  }
  if (pageStep < activeStep || pageState?.valid) {
    return {
      variant: 'done',
      navigationAllowed: true,
      valid: prevPageState?.valid
    };
  }
  return {
    variant: 'todo'
  };
};
const CheckoutStep = _ref => {
  let {
      route
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    variant,
    navigationAllowed,
    valid
  } = useVariant(route);
  const step = __jsx(_WizardStep.default, (0, _extends2.default)({}, rest, {
    variant: variant,
    valid: valid
  }));
  const suffix = (0, _useCheckoutPages.getSuffixForRoute)(route);
  return navigationAllowed ? __jsx(_link.default, {
    href: `/${suffix}`,
    as: `/${suffix}`,
    legacyBehavior: true
  }, step) : step;
};
const Container = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "CheckoutSteps__Container",
  componentId: "sc-12zxcd4-0"
})(["margin-bottom:7.2rem;@media screen and (max-width:", "){width:calc(100% + (var(--wrapperPadding) * 2));margin-left:calc(var(--wrapperPadding) * -1);margin-bottom:", ";}> *{width:25%;}"], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.spacing['70_XLarge']);